<app-dfp-panel
  title="Faturamento"
  [titleNote]="scaleTitleNote"
  [collapsible]="collapsible"
  [collapsed]="false"
  [collapseCommand]="collapseCommand">
  <!-- (i) "De onde vem cada mês" (card 3700): abre o modal com a origem de cada mês. Pontinho âmbar quando há
       declarações que se sobrepõem. Fora do modo somente leitura (`originCompanyId` nulo). -->
  @if (originCompanyId) {
    <button
      panelTitleAddon
      type="button"
      class="revenue-origin-trigger"
      [class.revenue-origin-trigger--alert]="originDialog.hasOverlap()"
      [pTooltip]="
        originDialog.hasOverlap()
          ? 'De onde vem cada mês: há declarações que se sobrepõem'
          : 'De onde vem cada mês'
      "
      tooltipPosition="top"
      [attr.aria-label]="
        originDialog.hasOverlap()
          ? 'De onde vem cada mês: há declarações que se sobrepõem'
          : 'De onde vem cada mês'
      "
      data-testid="revenue-origin-trigger"
      (click)="originDialog.open()">
      <i class="pi pi-info-circle" aria-hidden="true"></i>
    </button>
  }
  <ng-container panelActions>
    @if (allowExport) {
      <app-button
        icon="pi pi-download"
        [pureIcon]="true"
        [text]="true"
        title="Exportar"
        (sendClick)="exportMenu.toggle($event)" />
      <p-menu #exportMenu [popup]="true" [model]="exportMenuItems" [appendTo]="'body'" />
    }
  </ng-container>

  <div class="performance-table performance-table--revenue" appDfpClipGuard>
    <p-table [value]="groupedRevenueStatement" [tableStyle]="{ 'min-width': '100%' }">
      <ng-template pTemplate="header">
        <tr>
          <th appDfpColumnWidth="revenue:name">Mês</th>
          @for (year of uniqueYears; track year; let last = $last; let i = $index) {
            <th
              [appDfpColumnWidth]="'revenue:' + year"
              [class.is-latest]="last"
              [class.is-zebra]="i % 2 === 1">
              {{ year }}
            </th>
          }
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-group>
        <tr [class.is-total]="group.month === 0">
          <td class="nowrap">{{ group.month | vaultMonthIndex }}</td>
          @for (year of uniqueYears; track year; let last = $last; let i = $index) {
            <td [class.is-zebra]="i % 2 === 1" [class.is-latest]="last">
              {{ formatValue(getValueByYear(group.historic, year)) }}
            </td>
          }
        </tr>
      </ng-template>
    </p-table>
  </div>
</app-dfp-panel>

<app-revenue-origin-dialog
  #originDialog
  [companyId]="originCompanyId"
  (originChanged)="originChanged.emit()" />
